module.exports = __webpack_public_path__ + "static/media/try-dragonchain@phone.70ca61f8.jpg";